import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

export enum 日期格式 {
    年月 = 'YYYY年MM月',
    年月日 = 'YYYY年MM月DD日',
    年月日时 = 'YYYY年MM月DD日 HH点',
    年月日时分 = 'YYYY年MM月DD日 HH点mm分',
    年月日时分秒 = 'YYYY年MM月DD日 HH点mm分ss秒',
    年_月 = 'YYYY-MM',
    年_月_日 = 'YYYY-MM-DD',
    年_月_日_时 = 'YYYY-MM-DD HH:00',
    年_月_日_时_分 = 'YYYY-MM-DD HH:mm',
    年_月_日_时_分_秒 = 'YYYY-MM-DD HH:mm:ss',
}

export class DateFormatter {
    static Init() {
        dayjs.extend(customParseFormat);
    }

    static format(date: Date, formatString: string) {
        return dayjs(date).format(formatString);
    }
    static parse(dateString: string) {
        return dayjs(dateString).toDate();
    }
}

export class DateConverter {
    static Init() {
        dayjs.extend(customParseFormat);
    }

    static format(date: Date, formatString: string) {
        return dayjs(date).format(formatString);
    }
    static parse(dateString: string, formatString: string) {
        const result = dayjs(dateString, formatString, true);
        if (!result.isValid()) throw Error('日期转换错误');
        return result.toDate();
    }
    static convert(dateString: string, sourceFormat: string, targetFormat: string) {
        const result = dayjs(dateString, sourceFormat, true);
        if (!result.isValid()) throw Error('日期转换错误');
        return result.format(targetFormat);
    }
}
